export default __webpack_public_path__ + "static/media/icon-ofd.8a1e6cd7.gif";